import React from 'react';
import './Modal.scss';
import StyledWrapper from './ModalStyle';

export interface ModalProps {
  onDismiss?: () => void;
  type?: 'default' | 'small';
}

const Modal: React.FC<ModalProps> = ({ children, type = 'default' }) => {
  return (
    <StyledWrapper>
      <div className={`maximus-modal-wrapper ${type}`}>
        <div className="maximus-modal">{children}</div>
      </div>
    </StyledWrapper>
  );
};

export default Modal;
